import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { CustomizerSettingsService } from 'src/app/components/customizer-settings/customizer-settings.service';
import { DriveTypeIds } from 'src/app/core/constants/drive-const';
import { PaginationType } from 'src/app/core/interfaces/pagination/pagination-type';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { MyDriveService } from 'src/app/core/services/myDrive/my-drive.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { fileLogo } from 'src/app/core/helpers/helperfunc';
import moment from 'moment';
import { DrivePayloadType } from 'src/app/core/interfaces/file-manager/file-manager.interface';
import { ShareDialogComponent } from 'src/app/views/file-manager/shared/share-dialog/share-dialog.component';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';
import { FileManagerConst } from 'src/app/core/constants/file-manager.const';
import { PageEvent } from '@angular/material/paginator';
import { urlRoutes } from 'src/app/core/constants/url-route.constant';
import { Router } from '@angular/router';
import { CreateFolderDialogComponent } from 'src/app/views/file-manager/shared/create-folder-dialog/create-folder-dialog.component';
import { CreateFileDialogComponent } from 'src/app/views/file-manager/shared/create-file-dialog/create-file-dialog.component';
import { PopUpService } from 'src/app/core/services/pop-up/pop-up.service';

@Component({
  selector: 'app-list-view',
  templateUrl: './list-view.component.html',
  styleUrls: ['./list-view.component.scss']
})
export class ListViewComponent implements OnInit, OnChanges, OnDestroy {
  @Input() payload_entity: DrivePayloadType;
  @Input() layout: string;
  @Input() drive_type: number;
  @Input() drive_title: string;

  fmanager_module_ids = FileManagerConst.DriveTypeIds;
  pagination_config: PaginationType = {
    size: 10,
    total: 0,
    skip: 0,
    limit: 10
  };
  private _unsubscribeAll: Subject<any> = new Subject();
  drive_document_list: any;
  user_details: any;
  drive_action_type = FileManagerConst.DriveActionType;
  is_loading: boolean = false;
  drive_titles = FileManagerConst.DriveTitles;
  drive_count_list: any;

  constructor(
    public themeService: CustomizerSettingsService,
    public dialog: MatDialog,
    private _driveService: MyDriveService,
    private _loaderService: LoaderService,
    private _toasterSevrice: ToasterService,
    private _authService: AuthenticationService,
    private _router: Router,
     private popUpService: PopUpService
  ) {
    this.user_details = this._authService.getLoginUserDetails();
   }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['payload_entity']?.currentValue) {
      this.payload_entity = changes['payload_entity']?.currentValue;
      this.getData();
    }
    if (changes['drive_type']?.currentValue) { 
      this.drive_type = changes['drive_type']?.currentValue;
    }
  }

  ngOnInit(): void {
    
  }
  renameDocument(document: any): void {
    const dialogRef = this.dialog.open(CreateFolderDialogComponent, {
        width: '510px',
        data: {
            id: document.id,
            name: document.name,
            type: document.type,
        },
    });

    dialogRef.afterClosed().subscribe((result) => {
        if (result) {
            this.getData(); 
        }
    });
}
deleteDocument(document: any): void {
  this.popUpService.showConfirmationPopup(
      'Are you sure?',
      `You want to delete this ${document.type === 'folder' ? 'folder' : 'file'}?`,
      'Yes',
      (isConfirmed: boolean) => {
          if (isConfirmed) {
              if (document.type === 'folder') {
                  this.deleteFolder(document);
              } else {
                  this.deleteFile(document);
              }
          }
      },
      false,
      'No'
  );
}

deleteFolder(folder: any): void {
  this._loaderService.showLoader();
  this._driveService.removeFolder(folder.id)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
          this._toasterSevrice.showSuccess('SUCCESS', 'Folder deleted successfully!');
          this.getData(); 
      }, (err) => {
          this._loaderService.hideLoader();
      });
}

deleteFile(file: any): void {
  this._loaderService.showLoader();
  this._driveService.removeFile(file.id)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
          this._toasterSevrice.showSuccess('SUCCESS', 'File deleted successfully!');
          this.getData(); 
      }, (err) => {
          this._loaderService.hideLoader();
      });
}
  getData() {
    let payload = '';
    Object.keys(this.payload_entity).forEach(element => {
      payload += `${element}=${this.payload_entity[element]}&`
    })

    this.is_loading = true;
    this._loaderService.showLoader();
    this._driveService.getFolderFile(this.pagination_config, payload)
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe((res: any) => {
      console.log(res?.data?.data);
      const data = this.getFileConvertedData(
        res?.data?.data || []
      );
      
      
      this.drive_document_list = data.map((item: any) => {
        return {
            ...item,
            count: item.count || 0,
        };
    });
      this.drive_count_list = res?.data?.data.map((v) => v.count).filter(count => count !== "0");
      this.pagination_config.total = res?.data?.total;
      this._loaderService.hideLoader();
      this.is_loading = false;
      console.log(this.drive_count_list);
      
    }, (err) => {
      this._loaderService.hideLoader();
      this.is_loading = false;
    })
  }

  getFileConvertedData(data: any): any[] {
    const converted = data.map((item: any) => {
      item.shareUsers.push(item.user);
      return {
        // icon: item?.type === '0' ? 'folder.png' : fileLogo(item?.name),
        icon: item?.docType === 'true' ? fileLogo(item?.name) : 'folder.png',
        type: item?.docType === 'true' ? 'file' : 'folder',
        timestamp: item?.assignDate ? (moment().isSame(moment.unix(item?.assignDate), 'day') ? moment.unix(item?.assignDate).format('LT') : moment.unix(item?.assignDate).format('LL'))  : '-',
        shareUsers: item?.shareUsers?.length ? item?.shareUsers?.map(element => {
          element.remain_count = item?.shareUsers?.length > 3 ? (item?.shareUsers?.length - 3) : null;
          element.initial = element?.userDetails?.firstName?.charAt(0).toUpperCase() + element?.userDetails?.lastName?.charAt(0).toUpperCase(),
          element.name = `${element?.userDetails?.firstName ?? ''} ${element?.userDetails?.lastName ?? ''}`;
          element.role = element?.jobRoleDetails?.name ? ` (${element?.jobRoleDetails?.name})` : '';
          return element;
        }) : [],
        ...item
      }
    })
    return converted;
  }
 
  download(element: any) {
    this._loaderService.showLoader();
    this._driveService.fileDetails(element.id)
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe((res: any) => {
      if (res && res?.data?.data) {
        window.open(res?.data?.data?.res, '_blank');
      }
      this._loaderService.hideLoader();
    }, (err) => {
      this._loaderService.hideLoader();
    })
  }

  important(type: string, element: any) {
    this.bulkUpdate(type, element?.id);
  }

  share(type: string, element: any) {
    const dialogRef = this.dialog.open(ShareDialogComponent, {
      width: '40%',
      enterAnimationDuration: '300ms',
      exitAnimationDuration: '100ms',
      data: element,
    });
    dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.bulkUpdate(type, element?.id, result);
        }
    });
  }

  bulkUpdate(type: string, doc_id: string, user_id?: any) {
    let payload = '';

    if (type === this.drive_action_type.important || type === this.drive_action_type.unimportant) {
      payload = `Id=${doc_id}&type=${type === this.drive_action_type.important ? DriveTypeIds.important : DriveTypeIds.home}&userId=${this.user_details.id}`;
    } else if (type === this.drive_action_type.share) {
      payload = `Id=${doc_id}&type=${DriveTypeIds.share}&userId=${this.user_details.id}&sharedUserId=${user_id}`;
    }

    this._loaderService.showLoader();
    this._driveService.updateFile(payload)
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(res => {
      this.getData();
      this._toasterSevrice.showSuccess('SUCCESS', '');
    }, (err) => {
      this._loaderService.hideLoader();
    })
  }

  createFolder(element?: any): void {
    if (element) {
      element.type = this.drive_type,
      element.path = this.payload_entity.folderPath;
    }
    const dialogRef = this.dialog.open(CreateFolderDialogComponent, {
      width: '510px',
      enterAnimationDuration: '300ms',
      exitAnimationDuration: '100ms',
      data: {
        id: element?.id,
        name: element?.name,
        type: this.drive_type,
        folderPath: this.payload_entity.folderPath
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.getData();
      }
    })
  }

  uploadFile(): void {
    const dialogRef = this.dialog.open(CreateFileDialogComponent, {
      width: '100%',
      enterAnimationDuration: '300ms',
      exitAnimationDuration: '100ms',
      data: {
        filePath: this.payload_entity.folderPath
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.getData();
      }
    })
  }
  
  public pagination(event: PageEvent) { //add function to component ts file
    this.pagination_config.skip = (event.pageIndex * event.pageSize);
    this.pagination_config.limit = event.pageSize;
    this.getData();
  }

  navigateToFolders(element: any) {
    let route_module: string;
    let module_name: string;
    let folder_details: any[] = [];
    if (this.drive_type === this.fmanager_module_ids.home) {
      route_module = urlRoutes.my_drive;
      module_name = this.drive_titles.my_drive;
    } else if (this.drive_type === this.fmanager_module_ids.important) {
      route_module = urlRoutes.important;
      module_name = this.drive_titles.important;
    } else if (this.drive_type === this.fmanager_module_ids.share_with_me) {
      route_module = urlRoutes.shared_with_me;
      module_name = this.drive_titles.shared_with_me;
    } else if (this.drive_type === this.fmanager_module_ids.share_with_me) {
      route_module = urlRoutes.shared_by_me;
      module_name = this.drive_titles.shared_by_me;
    }
    let url = `${urlRoutes.mainLayout}/${urlRoutes.file_manager}/${route_module}/${urlRoutes.folders}/${element.id}`;
    if (this._router.url.includes('/folders')) {
      folder_details = this._driveService.getFolderBreadcrumb();
      let find_id = folder_details.findIndex(item => item.id === element?.id);
      if (find_id === -1) {
        folder_details.push({ id: element?.id, name: element?.name, url: url });
      }
      this._router.routeReuseStrategy.shouldReuseRoute = () => false;
      this._router.onSameUrlNavigation = 'reload';
    } else {
      folder_details.push(
        {
          id: '', 
          name: module_name, 
          url: this._router.url
        },
        {
          id: element.id, 
          name: element.name, 
          url: url
        }
      );
    }
    this._driveService.storeBreadcrumb(folder_details);
    this._router.navigate([url]);
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
